import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { selectTagSummariesForCurrentBib, selectTagsPaginationForCurrentBib } from 'app/selectors/bibs/UgcSelector';
import CommunityTags from './CommunityTags';

export class CommunityTagsContainer extends React.PureComponent {
  render() {
    return <CommunityTags {...this.props} />;
  }
}

CommunityTagsContainer.propTypes = {
  metadataId: PropTypes.string.isRequired,
  tags: ImmutablePropTypes.list.isRequired,
  pagination: ImmutablePropTypes.map
};

const mapStateToProps = state => ({
  tags: selectTagSummariesForCurrentBib(state),
  pagination: selectTagsPaginationForCurrentBib(state)
});

export default connect(mapStateToProps)(CommunityTagsContainer);
